import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  background: black;
  @media (max-width: 768px) {
    background: white;
  }
`;

const fadeKeyFrames = keyframes`
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
`;

const fade = css`
  animation: ${fadeKeyFrames} 2s;
`;

const efectPrimaryBackground = css`
  color: ${(props) => props.theme.colors.primary};
  background-color: white;
  transition: 0.6s ease;

  &:hover {
    color: white;
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export const Slide = styled.div`
  display: none;
  position: relative;
  width: 100%;
  height: 100%;

  &.active {
    display: block;
  }

  ${fade};
`;

export const Image = styled.img`
  background: #dddddd;
  margin: 0;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
  @media (max-width: 768px) {
    position: absolute;
    top: 50%;
  }
`;

export const ButtonImageHigh = styled.a`
  background-color: ${(props) => props.theme.colors.textInBg};
  color: ${(props) => props.theme.colors.textBlue};
  cursor: pointer;
  position: absolute;
  transform: translateY(-50%);
  bottom: -10px;
  left: 10px;
  padding: 3px 12px;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  border-radius: 7px;
  border-color: #ffffff;
  width: 150px;
  @media (max-width: 768px) {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.textInBg};
    bottom: -80px;
    left: 0px;
    border-radius: 7px;
  }
`;

export const Arrow = styled.a`
  ${efectPrimaryBackground};
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  border-radius: 50%;
`;

export const ArrowLeft = styled(Arrow)`
  left: 5px;
`;

export const ArrowRight = styled(Arrow)`
  right: 5px;
`;

export const Text = styled.p`
  font-size: 12px;
  padding: 3px 12px;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 7px;

  @media (max-width: 768px) {
    width: 100%;
    bottom: -50px;
    background-color: ${(props) => props.theme.colors.primary};
    color: #ffffff;
  }

  ${efectPrimaryBackground};
`;

export const NumberText = styled.div`
  font-size: 12px;
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 1;
  background: white;
  border-radius: 7px;
  color: black;
  padding: 5px 10px;

  ${efectPrimaryBackground};
`;
